<template>
	<v-expand-transition appear>
		<ValidationProvider tag="div" class="overflow-hidden" :name="$attrs.name" :rules="rules" v-slot="{ errors }">
		<div class="text-h4 my-3" v-html="question.options.label[lang]"></div>

		<v-textarea
			:error-messages="errors"
			v-model="inputValue"
			:hint="question.options.hint ? question.options.hint[lang] : ''"
			:persistent-hint="question.options.persistentHint"
			:outlined="question.options.outlined"
			:solo="question.options.solo"
			:min="question.options.min"
			:max="question.options.max"
			:rows="question.options.rows"
			:hide-details="!question.options.persistentHint"
			class="mb-6 mb-sm-8 pt-1"
			:clear-icon="question.options.clearIcon"
			:clearable="question.options.clearable"
			@input="setValue()"
		></v-textarea>
	</ValidationProvider>
	</v-expand-transition>
</template>

<script>
import {ValidationProvider} from "vee-validate";
import AppStore from "../../../stores/AppStore";
import _ from "lodash";
import {EventBus} from "../../../services/Request";

export default {
	name: 'textarea-viewer',

	components: {
		ValidationProvider
	},

	props: {
		value: {
			type: [Object],
			default() {
				return {}
			}
		},
		lang: {
			type: [String],
			default: 'fr'
		},
		rules: {
			type: [Object, String],
			default: ""
		},
		questionIndex: {
			type: [Number],
			default: 0
		},
	},

	data: () => ({
		inputValue: ''
	}),

	mounted() {

	},

	created() {
		if (!_.isEmpty(AppStore.rating.questions_answers) && AppStore.rating.questions_answers[this.question.id]) {
			this.inputValue = AppStore.rating.questions_answers[this.question.id].content
		}
	},

	computed: {
		question: {
			get() {
				return this.value;
			},

			set(newValue) {
				this.$emit('input', newValue)
			}
		},
	},

	watch: {},

	methods: {
		setValue() {
			EventBus.$emit('setQuestionAnswer', {
				question: this.question,
				inputValue: this.inputValue,
			})
		}
	}
};
</script>
